// theme.announcement = (function () {
//   function announcementModule(e) {
//       let sliderWrapper = e.querySelector(".announcement--slider-init"),
//       slideLoop = e.dataset.slideLoop,
//       slideAutoplay = e.dataset.slideAutoplay,
//       autoplayDuration = e.dataset.autoplayDuration,
//       slideLoopValue = true,
//       autoplay = false,
//       slideNavPrev = e.querySelector(".swiper-button-prev"),
//       slideNavNext = e.querySelector(".swiper-button-next"),
//       sliderPagination = e.querySelector(".swiper-pagination");

    
//     if (slideLoop == "false") {
//       slideLoopValue = false;
//     }
//     if (slideAutoplay == "true") {
//       let sliderDuration = parseInt(autoplayDuration);
//       autoplay = { delay: autoplayDuration, disableOnInteraction: false };
//     }
        
//     var swiper = new Swiper(sliderWrapper, {
//       slidesPerView: 1,
//       autoplay: autoplay,
//       loop: slideLoopValue,
//       clickable: true,
//       speed: 1000,
//       spaceBetween: 20,
//       pagination: {
//         el: sliderPagination,
//         clickable: true,
//       },
//       navigation: {
//         nextEl: slideNavNext,
//         prevEl: slideNavPrev,
//       }
//     });
//   }
//   return announcementModule;
// })();

// class announmentBar extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener("click", this.onRemoveAnnouncement);
//   }
//   onRemoveAnnouncement(event) {
//     let evtTargetElement = event.target;
//     if (evtTargetElement.classList.contains("announcement--timer-close-btn")) {
//       evtTargetElement.closest(".announcement-bar").remove();
//     }
//   }
// }
// customElements.define("announcement-bar", announmentBar);


theme.announcement = (function () {
  function announcementModule(e) {
    const marquee = e.querySelector(".announcement-marquee");
    if (!marquee) return;

    const track = marquee.querySelector(".announcement-marquee__track");
    const groups = marquee.querySelectorAll(".announcement-marquee__group");
    if (!track || groups.length < 2) return;

    const groupA = groups[0];
    const groupB = groups[1];
    const baseHTML = groupA.innerHTML;
    const speed = parseFloat(e.dataset.marqueeSpeed) || 60; // px per second
    let lastWidth = 0;

    function build() {
      // reset to the original content
      groupA.innerHTML = baseHTML;
      groupB.innerHTML = baseHTML;

      const singleWidth = groupA.offsetWidth;
      const containerWidth = marquee.offsetWidth;
      if (!singleWidth || !containerWidth) return;

      // repeat the messages so one group is always wider than the screen
      const repeats = Math.max(1, Math.ceil(containerWidth / singleWidth));
      if (repeats > 1) {
        groupA.innerHTML = baseHTML.repeat(repeats);
        groupB.innerHTML = baseHTML.repeat(repeats);
      }

      // constant speed on every screen size
      const duration = groupA.offsetWidth / speed;
      track.style.setProperty("--marquee-duration", duration.toFixed(2) + "s");

      // the duplicate copy is only for the loop: keep it out of keyboard focus
      groupB.querySelectorAll("a, button").forEach(function (el) {
        el.setAttribute("tabindex", "-1");
      });
    }

    build();
    lastWidth = marquee.offsetWidth;

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(build);
    }

    if ("ResizeObserver" in window) {
      new ResizeObserver(function () {
        const width = marquee.offsetWidth;
        if (width !== lastWidth) {
          lastWidth = width;
          build();
        }
      }).observe(marquee);
    } else {
      window.addEventListener("resize", function () {
        build();
      });
    }
  }
  return announcementModule;
})();

class announmentBar extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onRemoveAnnouncement);
  }
  onRemoveAnnouncement(event) {
    let evtTargetElement = event.target;
    if (evtTargetElement.classList.contains("announcement--timer-close-btn")) {
      evtTargetElement.closest(".announcement-bar").remove();
    }
  }
}
if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", announmentBar);
}
